import swal from "sweetalert";
import { globalFileUploader } from "../../jsx/components/UIComponents/uploader";
import {
  login,
  logout,
  runLogoutTimer,
  saveTokenInStorage,
  signUp,
  socialLogin,
} from "../../services/AuthService";
import formatError from "../../services/FormatError";

export const SIGNUP_CONFIRMED_ACTION = "[signup action] confirmed signup";
export const SIGNUP_FAILED_ACTION = "[signup action] failed signup";
export const LOGIN_CONFIRMED_ACTION = "[login action] confirmed login";
export const LOGIN_FAILED_ACTION = "[login action] failed login";
export const LOADING_TOGGLE_ACTION = "[Loading action] toggle loading";
export const LOGOUT_ACTION = "[Logout action] logout action";

export const NAVTOGGLE = "NAVTOGGLE";

export function signupAction(config, navigate) {
  return (dispatch) => {
    signUp(config)
      .then(async (response) => {
        // await globalFileUploader(
        //   config.photo,
        //   "PROFILE_PIC",
        //   response?.data?.result?.user?.id
        // );
        // Login(response.data?.result?.user?.username, response.data?.result?.user?.confirmpassword, config.navigate, dispatch);
        // saveTokenInStorage(response.data);
        // runLogoutTimer(
        //     dispatch,
        //     60 * 60 * 1000,
        //     navigate,
        // );
        // const errorMessage = formatError(error.response.data?.error?.message);
        // dispatch(confirmedSignupAction(response.data));
        // if (response?.data?.result?.user?.buyerprofile === 0 && response?.data?.result?.user?.sellerprofile === 0 && response?.data?.result?.user?.professional === 0) {
        // }

        navigate("/login?lang=fr", { replace: true });
        if (window.location.pathname === "/") {
          navigate("/login?lang=fr", { replace: true });
        }

        swal(
          "Success",
          response?.data?.result?.message || "Account registered successfully",
          "success"
        );
      })
      .catch((error) => {
        const errorMessage = formatError(error.response?.data?.error);
        dispatch(signupFailedAction(errorMessage));
      });
  };
}
export function socialLoginAction(provider, navigate) {
  return (dispatch) => {
    socialLogin(provider, navigate)
      .then((response) => {
        console.log("social action", response);
        // Login(response.data?.result?.user?.username, response.data?.result?.user?.confirmpassword, config.navigate, dispatch);
        // saveTokenInStorage(response.data);
        // runLogoutTimer(
        //     dispatch,
        //     60 * 60 * 1000,
        //     navigate,
        // );
        // const errorMessage = formatError(error.response.data?.error?.message);
        // dispatch(confirmedSignupAction(response.data));

        // navigate("/login");
        // swal("Success", response.data.result.message, "success");
      })
      .catch((error) => {
        const errorMessage = formatError(error.response?.data?.error);
        dispatch(signupFailedAction(errorMessage));
      });
  };
}

export function Login(username, password, navigate, dispatch) {
  login(username, password)
    .then((response) => {
      saveTokenInStorage(response.data);
      runLogoutTimer(dispatch, 60 * 60 * 1000, navigate);
      dispatch(loginConfirmedAction(response.data));
      // updateWebSocket()
      // 	.then((res) => {
      // 		console.log(res);
      // 	})
      // 	.catch((err) => {
      // 		console.log(err);
      // 	});
      if (response.data?.result?.user?.ispasswordtemporary === true) {
        navigate("/changepassword", { replace: true });
      } else if (
        response.data?.result?.role?.id === 3 &&
        response.data?.result?.user?.buyerprofile?.id &&
        response.data?.result?.user?.sellerprofile?.id
      ) {
        navigate("/suggestion", { replace: true });
      } else if (response.data?.result?.role?.id === 4) {
        navigate("/assignbusiness", { replace: true });
      } else if (response.data?.result?.role?.id === 5) {
        navigate("/assignbusiness", { replace: true });
      } else {
        navigate("/business", { replace: true });
      }
    })
    .catch((error) => {
      const errorMessage = formatError(error.response?.data?.error);
      dispatch(loginFailedAction(errorMessage));
    });
}

export function loginAction(username, password, navigate) {
  return (dispatch) => {
    Login(username, password, navigate, dispatch);
  };
}

export function Logout(navigate, flag) {
  return (dispatch) => {
    if (flag === true) {
      sessionStorage.removeItem("userDetails");
      navigate("/login", { replace: true });
      if (window.location.pathname === "/") {
        navigate("/login?lang=fr", { replace: true });
      }

      dispatch({
        type: LOGOUT_ACTION,
      });
    } else {
      logout()
        .then((response) => {
          sessionStorage.removeItem("userDetails");
          navigate("/login", { replace: true });
          if (window.location.pathname === "/") {
            navigate("/login?lang=fr", { replace: true });
          }
          dispatch({
            type: LOGOUT_ACTION,
          });
        })
        .catch((error) => {
          const errorMessage = formatError(error.response?.data?.error);
          dispatch(signupFailedAction(errorMessage));
        });
    }
  };
}

export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}

export const navtoggle = () => {
  return {
    type: "NAVTOGGLE",
  };
};
